import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAdminDashboard = (queryParams) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.adminDashboard,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: queryParams,
  });
};
export const fetchBuyerDashboard = (queryParams) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.buyerDashboard,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: queryParams,
  });
};
export const fetchSellerDashboard = (queryParams) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.sellerDashboard,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: queryParams,
  });
};
